module.exports = __webpack_public_path__ + "static/media/front_picture.2b1f977e.png";